module.exports = __webpack_public_path__ + "img/dt_a.e67b49c7.gif";